
import Vue from 'vue';
import { marked } from 'marked';

const parseMarkdown = (marked as unknown as { parse: (src: string, options?: object) => string }).parse;

export default Vue.extend({
  name: 'MarkedRenderer',
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    renderedHtml() {
      try {
        if (!this.value || this.value.trim() === '') {
          return '<p>Content is not available.</p>';
        }
        return parseMarkdown(this.value, {
          sanitize: true,
          baseUrl: window.location.origin
        });
      } catch (error) {
        console.error('Markdown rendering error:', error);
        return '<p>Error loading content. Please try refreshing the page.</p>';
      }
    },
  },
});
